/**
 * Asynchronously loads the component for AddAssessments
 */
import Loadable from "react-loadable";

export default Loadable({
  loader: () => import("."),
  loading: () => null
});
